import React from 'react';
import { Box, Typography } from '@mui/material';
import { NodeIcon } from '../CustomNode';

function NodeHeader({ type, id }) {
  return (
    <Box display="flex" gap={1.5} alignItems="center">
      <Box
        sx={{
          p: 1,
          bgcolor: 'rgba(255,255,255,0.2)',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Box
          component="span"
          sx={{ fontSize: 20, opacity: 0.9, display: 'flex' }}>
          <NodeIcon type={type} />
        </Box>
      </Box>
      <Box>
        <Typography variant="subtitle1" fontWeight="bold" lineHeight={1.2}>
          {type.replace('_', ' ')}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            opacity: 0.8,
            fontFamily: 'monospace',
            display: 'block',
            mt: 0.5,
          }}>
          {id}
        </Typography>
      </Box>
    </Box>
  );
}

export default NodeHeader;
